<template>
  <v-content>
    <v-container class="pa-0" style=" margin-left: auto; margin-right: auto; overflow:hidden;">
      <v-content class="pa-0">
        <v-card id="main-card">
          <dialog-ask-for-age v-if="showAgeCheck && !showAgeAlert"></dialog-ask-for-age>
          <age-alert-message></age-alert-message>
          <home-content-grid></home-content-grid>
          <home-footer-grid></home-footer-grid>
          <contract-accepted-message></contract-accepted-message>
        </v-card>
      </v-content>
    </v-container>
  </v-content>
</template>

<script>
import HomeContentGrid from "../components/HomeContentGrid";
import HomeFooterGrid from "../components/HomeFooterGrid";
import DialogAskForAge from "../components/DialogAskForAge";
import ContractAcceptedMessage from "../components/ContractAcceptedMessage";
import DialogNoCamNoFun from "../components/DialogNoCamNoFun";
import AgeAlertMessage from "../components/AgeAlertMessage.vue";

export default {
  name: "Home",
  components: { DialogNoCamNoFun, DialogAskForAge, HomeFooterGrid, HomeContentGrid, ContractAcceptedMessage, AgeAlertMessage },
  data: () => ({
    drawer: null
  }),
  props: {
    source: String
  },
  methods: {
  },
  computed: {
    ageGroup() {
      return this.$store.getters['work/getSupposedlyAgeGroup'];
    },
    showAgeCheck() {
      return (
        !this.$store.getters["work/getIgnoreAgeCheck"] ||
        this.$store.getters["work/getCookieBirthdateShowSelectNew"]
      );
    },
    showAgeAlert() {
      // return this.$store.getters["work/getIgnoreAgeCheck"] && this.ageGroup === 0;
      return ((
        this.$store.getters["work/getCookieBirthdateTooYoung"] ||
        this.$store.getters["work/getCookieBirthdateInvalid"]) &&
        !this.$store.getters["work/getCookieBirthdateShowSelectNew"]
      );
    }
    /* ,
    contractAccepted(){
      return this.$store.getters['work/getContractAcceptanceState'];
    } */
  },
  mounted() {
    document.querySelector('#vier-gewinnt-app').style.maxWidth = this.$store.state.viewportWidth + 'px';
  }
};
</script>

<style>
.theme--light.application {
  background-color: transparent !important;
}
</style>
